import { render, staticRenderFns } from "./SaleServiceItem.vue?vue&type=template&id=a4f95544&scoped=true&"
import script from "./SaleServiceItem.vue?vue&type=script&lang=js&"
export * from "./SaleServiceItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleServiceItem.vue?vue&type=style&index=0&id=a4f95544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f95544",
  null
  
)

export default component.exports